import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import { getEvent } from '@pingum/app-state-management/event/actions';
import { getStatuses } from '@pingum/app-state-management/status/actions';
import HistoryItem from '../HistoryItem';
import AddCommentCard from '../AddCommentCard';

import styles from './styles';

const MAX_SCROLL_HEIGHT = 100;
export class EventDetailPageComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showMoreComments: false };
  }

  componentDidUpdate({
    selectedEvent: {
      id: oldId,
      comments: oldComments = [],
    },
  }) {
    const {
      id,
      comments = [],
    } = this.props.selectedEvent;
    if (
      oldId !== id
        || oldComments.length !== comments.length
    ) {
      this.list.scrollTo(0, this.list.scrollHeight);
    }
  }

  handleScroll = () => {
    if (!this.state.showMoreComments && this.list.scrollTop > MAX_SCROLL_HEIGHT) {
      this.setState({ showMoreComments: true });
    } else if (this.state.showMoreComments && this.list.scrollTop <= MAX_SCROLL_HEIGHT) {
      this.setState({ showMoreComments: false });
    }
  }

  render() {
    const {
      selectedEvent,
      tenantUsers,
      isRestricted,
      classes,
    } = this.props;

    const eventStatuses = selectedEvent.eventStatus || [];
    const comments = selectedEvent.comments || [];
    const eventUploads = selectedEvent.eventUploads || [];

    const historyItems = [
      ...eventStatuses.sort((a, b) => a.id - b.id).map((eventStatus, index) => ({
        ...eventStatus,
        type: 'eventStatus',
        nextEventStatus: eventStatuses[index + 1] || {},
      })),
      ...eventUploads.map((eventUpload) => ({
        ...eventUpload,
        type: 'eventUpload',
      })),
      ...comments
        .filter((comment) => comment.commentHeader.indexOf('New Status For Event') === -1)
        .map((comment) => ({
          ...comment,
          type: 'comment',
        })),
    ];

    return (
      <div className={classes.container}>
        <div
          ref={(el) => { this.list = el; }}
          onScroll={this.handleScroll}
        >
          {
            historyItems.sort((a, b) => moment(a.createdDate).unix() - moment(b.createdDate).unix())
              .map((historyItem) => (
                <HistoryItem
                  key={`history-item-${historyItem.type}-${historyItem.id}`}
                  item={historyItem}
                  tenantUsers={tenantUsers}
                />
              ))
          }
        </div>
        {
          !isRestricted && <AddCommentCard />
        }
      </div>
    );
  }
}

EventDetailPageComponent.propTypes = {
  selectedEvent: PropTypes.object,
  tenantUsers: PropTypes.array,
  isRestricted: PropTypes.bool,
  classes: PropTypes.object,
};

EventDetailPageComponent.defaultProps = {
  selectedEvent: {},
  tenantUsers: [],
  isRestricted: false,
  classes: {},
};

export const mapStateToProps = (state) => ({
  selectedEvent: state.event.selectedEvent,
  statuses: state.status.statuses,
  tenantUsers: state.tenant.tenantUsers,
});

export const mapDispatchToProps = (dispatch) => ({
  getEvent: (id) => dispatch(getEvent(id)),
  getStatuses: () => dispatch(getStatuses()),
});

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps,
)(EventDetailPageComponent));
